import React, { useEffect } from "react";
import NavbarGuest from "./NavbarGuest";
import Footer from "./Footer";
import TermsofUseText from "./commonTextPages/TermsofUseText";
import WrapperContainer from "./utilities/WrapperContainer";

export default function TermsofUseHome() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="fullScreenLayout">
        <NavbarGuest />

        <WrapperContainer
          maxwidth="70%"
          title="Terms Of Use"
          content={<TermsofUseText />}
        />
        <div className="flex-grow-1"></div>
        <Footer />
      </div>
    </>
  );
}
